import axios from 'axios';

export default {
  data() {
    return {
      fileUrl: '',
      fileName: '',
      imageData: '',
      nameUpdated: '',
      token: (JSON.parse(localStorage.getItem('Token'))).value,
    };
  },

  methods: {
    handleFileUpload(e, useUploadFile) {
      const file = e.target.files;
      const isAcceptedType = ['image/jpeg', 'image/png'].includes(file[0].type);
      const fileSize = Math.round(file[0].size / 1024 / 1024);

      if (!isAcceptedType) {
        this.toggleProblem('Please choose a wanted file!');
      }

      if (fileSize > 5) {
        this.toggleProblem('Please upload file with maximum size 5MB!');
      }

      if (isAcceptedType && fileSize <= 5) {
        if (useUploadFile) {
          this.uploadFile(file, null, null);
        } else {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgUrl = event.target.result;
            this.nameUpdated = file[0].name;
            this.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file[0]);
        }
      }
    },

    async uploadFile(file, name, content) {
      this.showLoading();
      if (file) {
        const imagebase = await this.getBase64(file[0]).then(
          data => data,
        );
        const commaPosition = imagebase.lastIndexOf(',') + 1;
        this.imageData = imagebase.substring(commaPosition);
        this.fileName = file[0].name;
      }

      const sendData = {
        filename: name || this.fileName,
        content: content || this.imageData,
      };

      axios.post(`${process.env.GATE_URL}//file`, sendData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: this.token,
        },
      }).then((res) => {
        const data = res.data.data;
        const imageUrl = data.url;

        this.fileUrl = imageUrl;
        this.hideLoading();
      }).catch((error) => {
        this.hideLoading();
        this.error_message = error.response.data.message;
        this.toggleProblem(this.error_message);
      });
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
  },
};




// WEBPACK FOOTER //
// ./src/mixins/jMixWidgetBanner.js